import '../../../node_modules/codemirror/lib/codemirror.css';

window.components = {
  ...window.components,
  'CodeEditor': require('../components/CodeEditor')
}

window.mountComponents(window.components);
